import {loadManifest} from '@angular-architects/module-federation';
import {environment} from './environments/environment';

// Polyfill for Angular Signals + Module Federation compatibility
// See: https://github.com/angular/angular/issues/62796
// Must be defined before any Angular code loads
if (typeof (globalThis as any)['ngDevMode'] === 'undefined') {
  (globalThis as any)['ngDevMode'] = !environment.production;
}

const baseUrl = document.getElementsByTagName('base')[0].href;

loadManifest(`${baseUrl}assets/mf.manifest.json`, true)
  .catch(err => console.error(err))
  .then(_ => import('./bootstrap'))
  .catch(err => console.error(err));
